export default __webpack_public_path__ + "static/media/corporate-masthead.3d451579.png";